<form class="admin-filters" nz-form [formGroup]="searchForm" (ngSubmit)="submitFilterForm()">
  <div class="admin-filters__fields">
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-input-group [nzSuffix]="suffixIconSearch">
          <input
            type="text"
            formControlName="searchTerm"
            nz-input
            [placeholder]="'admin.filter.search.placeholder' | translate"
          />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <span *ngIf="!searchForm.get('searchTerm')?.value" nz-icon nzType="search"></span>
          <span
            nz-icon
            class="ant-input-clear-icon"
            nzTheme="fill"
            nzType="close-circle"
            *ngIf="searchForm.get('searchTerm')?.value"
            (click)="searchForm.get('searchTerm')?.setValue(null)"
          ></span>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-select
          class="mission-partner-filter"
          nzShowSearch
          nzAllowClear
          [nzPlaceHolder]="'admin.filter.mission-partner.placeholder' | translate"
          formControlName="missionPartnerId"
        >
          <nz-option
            *ngFor="let option of missionPartners"
            [nzLabel]="option.companyName"
            [nzValue]="option.accountId.internalId"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div class="admin-filters__actions">
    <nz-form-item>
      <nz-form-control>
        <button nz-button nzType="primary" [disabled]="!searchForm.valid">
          {{ "admin.filter.submit" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control>
        <button nz-button nzType="default" type="button" (click)="openCreateInvoiceModal()">
          {{ "admin.invoices.add.label" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
  </div>
</form>

<ng-template #rangeTemplate let-range="range" let-total>
  {{ range[0] }}-{{ range[1] }} of {{ total }} items
</ng-template>

<div class="desktop-only">
<nz-table
  class="sticky-table" [nzScroll]="{ x: '1200px' }"
  #basicTable
  [nzData]="tableState.data?.items || []"
  nzPaginationPosition="both"
  nzShowSizeChanger="true"
  nzSize="small"
  [nzShowTotal]="rangeTemplate"
  nzFrontPagination="false"
  [nzLoading]="tableState.loading"
  [nzTotal]="tableState.data?.paging?.items || 0"
  [nzPageSize]="tableState.data?.paging?.itemsOnPage || 0"
  [nzPageIndex]="tableState.data?.paging?.page || 0"
  (nzQueryParams)="onQueryParamsChange($event)"
>
  <thead>
    <tr>
      <th>{{ "admin.invoices.mp-name.title" | translate }}</th>
      <th>{{ "admin.invoices.date.title" | translate }}</th>
      <th>{{ "admin.invoices.number.title" | translate }}</th>
      <th>{{ "admin.invoices.status.title" | translate }}</th>
      <th>{{ "admin.action.title" | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of basicTable.data">
      <td>
        <a [routerLink]="['/admin/mission-partner-view', data.missionPartnerId]" target="_blank">
          {{ data.missionPartnerName }}
        </a>
      </td>
      <td>{{ data.date | date : "dd.MM.yyyy" }}</td>
      <td>{{ data.number }}</td>
      <td>
        <nz-select [ngModel]="data.invoiceStatus" (ngModelChange)="onChangeStatus($event, data.id)" style="width: 100%">
          <nz-option [nzLabel]="'invoices.status.new' | translate" nzValue="NEW"></nz-option>
          <nz-option [nzLabel]="'invoices.status.received' | translate" nzValue="RECEIVED"></nz-option>
          <nz-option [nzLabel]="'invoices.status.done' | translate" nzValue="DONE"></nz-option>
        </nz-select>
      </td>

      <td class="nowrap">
        <button
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="data.missionPartnerId"
          nzTooltipPlacement="top"
          nz-tooltip
          (click)="copyId(data.missionPartnerId)"
        >
          <span nz-icon nzType="info-circle" nzTheme="outline"></span>
        </button>
        <a
          *ngIf="data.invoiceFile"
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.download-invoice.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          [href]="appConfig.siteUrl + '/' + data.invoiceFile.fileUrl"
          target="_blank"
        >
          <span nz-icon nzType="download" nzTheme="outline"></span>
        </a>

        <button
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.delete-invoice.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          (click)="showDeleteConfirm(data)"
        >
          <span nz-icon nzType="delete" nzTheme="outline"></span>
        </button>
      </td>
    </tr>
  </tbody>
</nz-table>
</div>

<div class="mobile-only" style="margin-top: 16px;">
  <nz-pagination
    *ngIf="!tableState.loading"
    [nzPageIndex]="tableState.data?.paging?.page || 1"
    [nzTotal]="tableState.data?.paging?.items || 0"
    [nzPageSize]="tableState.data?.paging?.itemsOnPage || 10"
    (nzPageIndexChange)="onPageChange($event)"
    nzSize="small"
    [nzShowTotal]="rangeTemplate"
    style="margin-bottom: 16px; text-align: center;"
  ></nz-pagination>

  <nz-spin [nzSpinning]="tableState.loading">
    <div style="display: flex; flex-direction: column; gap: 16px;">
      <nz-card *ngFor="let data of tableState.data?.items || []" nzHoverable nzSize="small">
        <nz-row [nzGutter]="[0, 8]">
          <nz-col [nzSpan]="24">
            <strong>{{ "admin.invoices.mp-name.title" | translate }}:</strong>
            <div>
              <a [routerLink]="['/admin/mission-partner-view', data.missionPartnerId]" target="_blank">
                {{ data.missionPartnerName }}
              </a>
            </div>
          </nz-col>
          <nz-col [nzSpan]="12">
            <strong>{{ "admin.invoices.date.title" | translate }}:</strong>
            <div>{{ data.date | date : "dd.MM.yyyy" }}</div>
          </nz-col>
          <nz-col [nzSpan]="12">
            <strong>{{ "admin.invoices.number.title" | translate }}:</strong>
            <div>{{ data.number }}</div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <strong>{{ "admin.invoices.status.title" | translate }}:</strong>
            <div>
              <nz-select [ngModel]="data.invoiceStatus" (ngModelChange)="onChangeStatus($event, data.id)" style="width: 100%">
                <nz-option [nzLabel]="'invoices.status.new' | translate" nzValue="NEW"></nz-option>
                <nz-option [nzLabel]="'invoices.status.received' | translate" nzValue="RECEIVED"></nz-option>
                <nz-option [nzLabel]="'invoices.status.done' | translate" nzValue="DONE"></nz-option>
              </nz-select>
            </div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <nz-divider style="margin: 8px 0;"></nz-divider>
            <strong>{{ "admin.action.title" | translate }}:</strong>
            <div style="display: flex; flex-wrap: wrap; gap: 4px; margin-top: 8px;">
              <button nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="data.missionPartnerId" (click)="copyId(data.missionPartnerId)">
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
                Copy ID
              </button>
              <a *ngIf="data.invoiceFile" nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'admin.download-invoice.tooltip' | translate" [href]="appConfig.siteUrl + '/' + data.invoiceFile.fileUrl" target="_blank">
                <span nz-icon nzType="download" nzTheme="outline"></span>
                {{ "admin.download-invoice.tooltip" | translate }}
              </a>
              <button nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'admin.delete-invoice.tooltip' | translate" (click)="showDeleteConfirm(data)">
                <span nz-icon nzType="delete" nzTheme="outline"></span>
                {{ "admin.delete-invoice.tooltip" | translate }}
              </button>
            </div>
          </nz-col>
        </nz-row>
      </nz-card>
    </div>
  </nz-spin>

  <nz-pagination
    *ngIf="!tableState.loading"
    [nzPageIndex]="tableState.data?.paging?.page || 1"
    [nzTotal]="tableState.data?.paging?.items || 0"
    [nzPageSize]="tableState.data?.paging?.itemsOnPage || 10"
    (nzPageIndexChange)="onPageChange($event)"
    nzSize="small"
    [nzShowTotal]="rangeTemplate"
    style="margin-top: 16px; text-align: center;"
  ></nz-pagination>
</div>
